module.exports = __webpack_public_path__ + "static/95-bb5274fa5f2b621c36fca88c6a2d5db8.png";